import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=07e74241&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e74241",
  null
  
)

export default component.exports